import React from 'react';
import {connect} from 'react-redux';
import './leftMenu.css';
import SearchBar from '../SearchBar';
import LeftMenuItem from "./LeftMenuItem";

class LeftMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
            activeCategories: [],
            allCategories: [],
            initialLength: 0
        };

        const prepareCategories = discs => {
            let categories = {};
            discs.forEach(disc => {
                if (!categories[disc.category]) {
                    categories[disc.category] = [];
                }

                categories[disc.category].push(disc);
            });
            return categories;
        };

        const setSearchedDiscsCategories = searchValue => {
            let discs = [];
            let phrases = searchValue.toLowerCase()
                .split(" ").filter(phrase => phrase.length > 0);
            if (phrases.length) {
                this.props.krazki.forEach(disc => {
                    const searchedPhrases = phrases.filter(phrase => phrase.length > 1
                            ? disc.tags.join(' ').indexOf(phrase) !== -1
                            : disc.tags.find(tag => tag === phrase)
                    );
                    searchedPhrases.length > 0 && discs.push(disc);
                });
            }

            this.setState({activeCategories: prepareCategories(discs)})
        };

        const setDiscsCategories = () => {
            let categories = prepareCategories(this.props.krazki);
            this.setState({
                activeCategories: [],
                allCategories: categories,
                initialLength: Object.keys(categories).length
            })
        };

        this.setActiveCategories = searchValue => {
            searchValue.length > 0 ? setSearchedDiscsCategories(searchValue) : setDiscsCategories();
        };


        this.getSearchValue = e => {
            if (e) {
                this.setState({searchValue: e.target.value});
                this.setActiveCategories(e.target.value)
            } else {
                this.setState({searchValue: ''});
                this.setActiveCategories('')
            }
        };
    }

    componentDidMount() {
        this.setActiveCategories('');
    }

    render() {
        let categories = Object.keys(this.state.activeCategories).length > 0
            ? this.state.activeCategories
            : this.state.searchValue !== ''
                ? this.state.activeCategories
                : this.state.allCategories;
        let categoriesKeys = Object.keys(categories);
        let content = categoriesKeys.map(key => <LeftMenuItem
            key={key}
            category={key}
            isCollapsed={categoriesKeys.length !== this.state.initialLength}
            discs={categories[key]}
            krazki={this.props.krazki}
            mata={this.props.squaresState}
        />);

        return (
            <div id="leftMenu">
                <div id="mata-do-kodowania-title">
                    <img src="/akademia/image/mata do kodowania.svg" alt=""/>
                </div>
                <SearchBar getSearchValue={this.getSearchValue} searchValue={this.state.searchValue}/>
                {content}
            </div>
        )
    }
}

export default connect(
    state => ({
        language: state.language,
        krazki: state.krazki,
        squaresState: state.squaresState,
    })
)(LeftMenu)



// WEBPACK FOOTER //
// ./src/LeftMenu/LeftMenu.js